import React, {useState} from 'react';
import api from '../../../services/api';
import swal from 'sweetalert';
import './Asistencia.css'

const AsistenciaComponent = () => {
    const todayMazatlan = new Intl.DateTimeFormat('es-MX', {
        timeZone: 'America/Mazatlan',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).format(new Date());
    const [day, month, year] = todayMazatlan.split('/');
    const today = `${year}-${month}-${day}`;

    const [showSearch, setShowSearch] = useState(false);
    const [alumno, setAlumno] = useState([]);
    const [matricula, setMatricula] = useState(null);
    const [infoAlumno, setInfoAlumno] = useState([]);
    const [listaAlumnos, setListaAlumnos] = useState([]);

    const buscarAlumnos = async () => {
        setShowSearch(true);    
        try {
            const response = await api.getAlumnosAsistencias({alumno});
            setListaAlumnos(response.data.data);
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }
    }

    const registrarEntrada = async () => {
        try {
            await api.postRegistrarEntrada({matricula, today});
            const responseInfo = await api.getInfoAsistencia({alumno: {MATRICULA: matricula}, today});
            setInfoAlumno(responseInfo.data.data);
            await api.postMessageAsistencia({matricula, registro: 'entrada'});
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }
    }

    const registrarSalida = async () => {
        try {
            await api.postRegistrarSalida({matricula, today});
            const responseInfo = await api.getInfoAsistencia({alumno: {MATRICULA: matricula}, today});
            setInfoAlumno(responseInfo.data.data);
            await api.postMessageAsistencia({matricula, registro: 'salida'});
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }
    }

    async function selectAlumno(alumno) {
        const response = await api.getInfoAsistencia({alumno, today});
        setInfoAlumno(response.data.data);
        setMatricula(alumno.MATRICULA);
        setShowSearch(false);
    }

    return (
        <>
        <div className= "seccion-materias hover-seccion fade-in">
            <div className= "seccion-centro">
                <div className='container-asistencia'>
                    <div className='asistencia-buscar'>
                        <label htmlFor='student-name'>Nombre del Alumno:</label>
                        <input type='text' name='student-name' value={alumno} onChange={e => {setAlumno(e.target.value)}}></input>
                    </div>
                    <button onClick={buscarAlumnos} className='button-buscar-alumno'>BUSCAR</button>
                    <div className='asistencia-buttons'>
                        <button onClick={registrarEntrada} className={!matricula ? 'desactivado' : ''}>REGISTRAR ENTRADA</button>
                        <button onClick={registrarSalida} className={!matricula ? 'desactivado' : ''}>REGISTRAR SALIDA</button>
                    </div>
                </div>
                <div className= "seccion-tabla-asistencias">
                    <div className= "hover-elemento">
                        {/* TABLA */}
                        <div className= "container-table-buscar-alumno">
                            <table className= "table-asistencia-alumno">
                                <thead>
                                    <tr>
                                        <th><label>FECHA</label></th>
                                        <th><label>MATRICULA</label></th>
                                        <th><label>ALUMNO</label></th>
                                        <th><label>NIVEL</label></th>
                                        <th><label>GRADO</label></th>
                                        <th><label>GRUPO</label></th>
                                        <th><label>ENTRADA</label></th>
                                        <th><label>SALIDA</label></th>
                                        <th><label>MANUAL</label></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { infoAlumno && infoAlumno.map( (alumno, i) => { 
                                        return (
                                        <tr key={ i } onClick={e => selectAlumno(alumno)}>
                                            <td>{ alumno.FECHA.split('T')[0] }</td>
                                            <td>{ alumno.MATRICULA }</td>
                                            <td>{ alumno.ALUMNO }</td>
                                            <td>{ alumno.NIVEL }</td>
                                            <td>{ alumno.GRADO }</td>
                                            <td>{ alumno.GRUPO }</td>
                                            <td>{ alumno.ENTRADA }</td>
                                            <td>{ alumno.SALIDA }</td>
                                            <td>{ alumno.MANUAL }</td>
                                        </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        { showSearch ? <>
            <div className="overlay"></div>
            <div className='container-buscar-alumno'>
                <div className='title-buscar-alumno'>
                    <h3>SELECCIONA AL ALUMNO</h3>
                    <label className='button-close-buscar-alumno' onClick={e => setShowSearch(false)}> X </label>
                </div>
                <div className='container-table-buscar-alumno'>
                    <table className='table-buscar-alumno'>
                        <thead>
                            <tr>
                                <th><label>MATRICULA</label></th>
                                <th><label>ALUMNO</label></th>
                                <th><label>TURNO</label></th>
                                <th><label>GRADO</label></th>
                                <th><label>GRUPO</label></th>
                            </tr>
                        </thead>
                        <tbody>
                            { listaAlumnos && listaAlumnos.map( (alumno, i) => { 
                                return (
                                <tr key={ i } onClick={e => selectAlumno(alumno)}>
                                    <td>{ alumno.MATRICULA }</td>
                                    <td>{ alumno.ALUMNO }</td>
                                    <td>{ alumno.NIVEL }</td>
                                    <td>{ alumno.ID_GRADO }</td>
                                    <td>{ alumno.GRUPO }</td>
                                </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </> : ''}
        </>
    );
};

export default AsistenciaComponent;